// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compact-close-masive-options{
    height: 90%;
    width:90%;
    color:var(--txt-color);
    display:block;
    border: 2px solid var(--red-alert);
    border-radius: 10px;
    box-shadow: 3px 6px 10px rgba(0, 0, 0, 0.219);
}
.compact-close-masive-options:hover{
    /* height: 92%;
    width:92%; */
    background-color:#e8eaee98;
    cursor: pointer;
    box-shadow: 6px 8px 12px rgba(0, 0, 0, 0.267);
}
.compact-close-masive-options.close-masive-selected{
    
    background-color: var(--error-color);
   
}
.title-option-close-masive{
    display:flex;
    justify-content:center;
    align-items:center;
    text-align:center;
    color: var(--red-alert);
    /* font-weight: bold; */
    font-size: small;
    text-align: center;
    width: 80%;
    height: 30%;
    position: relative;
    left: 10%;
}
.body-option-close-masive{
    display:flex;
    justify-content:center;
    align-items:center;
    text-align:center;
    color: var(--text-color);
    font-size: xx-small;
    text-align: center;
    word-wrap: break-word;
    width: 90%;
    left: 5%;
    position: relative;
    height: 70%;
}
.close-masive-selected .body-option-close-masive,
.close-masive-selected .title-option-close-masive{
    color: var(--white-color);
}
.main-close-masive{
    display: block;
    width: 100%;
    height: 100%;
}
.buttons-close-masive ,.mode-close-masive{
    height: 14%;
    width:100%;
    display:flex;
    justify-content:center;
    align-items:center;
    gap:20px;
}
.buttons-close-masive{
    width: 50%;
    left: 25%;
    position: relative;
}
.body-close-masive{
    height: 70%;
    width:100%;
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
    gap:10px
}

.content-close-masive-options{
    position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 90%;
}
.mode-close-masive{
     box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.219);
     border: 1px solid rgba(128, 128, 128, 0.411);
     border-radius: 10px;
     width:90%; 
     position: relative;
     left: 5%;
    }
.title-text-close-masive{
    color: var(--main-color);
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}
.mode-option-close-masive{
    /* width:40%; */
    height: 100%;
    font-size: small;
    color: var(--txt-color);
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}   
.top-body-close-masive, .bottom-body-close-masive{
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.219);
     border: 1px solid rgba(128, 128, 128, 0.411);
     border-radius: 10px;
     width:90%; 
     position: relative;
     /* left: 10%; */
      height: 40%;
}
.top-body-close-masive{ 
    display:flex;
    flex-direction:row;
    align-items:center;
    justify-content:center;
    gap:10px
}
.bottom-body-close-masive{
    display:flex;
    flex-direction:row;
    align-items:center;
    justify-content:center;
    gap:10px;
    height: 50%;
}
.text-close-masive{
     background: var(--white-color);
     position:relative;
     resize:none;
     width:90%;
     height:60%;
     color: var(--txt-color);
     border-radius: 10px;
}
.lbl-text-close-masive{
    position: absolute;
    top: 5%;
    left: 5%;
    font-size: small;
    color: var(--txt-color);
}`, "",{"version":3,"sources":["webpack://./src/components/monitor-components/styles/ModalMasiveDelete.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,SAAS;IACT,sBAAsB;IACtB,aAAa;IACb,kCAAkC;IAClC,mBAAmB;IACnB,6CAA6C;AACjD;AACA;IACI;gBACY;IACZ,0BAA0B;IAC1B,eAAe;IACf,6CAA6C;AACjD;AACA;;IAEI,oCAAoC;;AAExC;AACA;IACI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,QAAQ;IACR,kBAAkB;IAClB,WAAW;AACf;AACA;;IAEI,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;AACZ;AACA;IACI,UAAU;IACV,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;AACA;KACK,4CAA4C;KAC5C,4CAA4C;KAC5C,mBAAmB;KACnB,SAAS;KACT,kBAAkB;KAClB,QAAQ;IACT;AACJ;IACI,wBAAwB;IACxB,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,4CAA4C;KAC3C,4CAA4C;KAC5C,mBAAmB;KACnB,SAAS;KACT,kBAAkB;KAClB,eAAe;MACd,WAAW;AACjB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB;AACJ;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,QAAQ;IACR,WAAW;AACf;AACA;KACK,8BAA8B;KAC9B,iBAAiB;KACjB,WAAW;KACX,SAAS;KACT,UAAU;KACV,uBAAuB;KACvB,mBAAmB;AACxB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,gBAAgB;IAChB,uBAAuB;AAC3B","sourcesContent":[".compact-close-masive-options{\r\n    height: 90%;\r\n    width:90%;\r\n    color:var(--txt-color);\r\n    display:block;\r\n    border: 2px solid var(--red-alert);\r\n    border-radius: 10px;\r\n    box-shadow: 3px 6px 10px rgba(0, 0, 0, 0.219);\r\n}\r\n.compact-close-masive-options:hover{\r\n    /* height: 92%;\r\n    width:92%; */\r\n    background-color:#e8eaee98;\r\n    cursor: pointer;\r\n    box-shadow: 6px 8px 12px rgba(0, 0, 0, 0.267);\r\n}\r\n.compact-close-masive-options.close-masive-selected{\r\n    \r\n    background-color: var(--error-color);\r\n   \r\n}\r\n.title-option-close-masive{\r\n    display:flex;\r\n    justify-content:center;\r\n    align-items:center;\r\n    text-align:center;\r\n    color: var(--red-alert);\r\n    /* font-weight: bold; */\r\n    font-size: small;\r\n    text-align: center;\r\n    width: 80%;\r\n    height: 30%;\r\n    position: relative;\r\n    left: 10%;\r\n}\r\n.body-option-close-masive{\r\n    display:flex;\r\n    justify-content:center;\r\n    align-items:center;\r\n    text-align:center;\r\n    color: var(--text-color);\r\n    font-size: xx-small;\r\n    text-align: center;\r\n    word-wrap: break-word;\r\n    width: 90%;\r\n    left: 5%;\r\n    position: relative;\r\n    height: 70%;\r\n}\r\n.close-masive-selected .body-option-close-masive,\r\n.close-masive-selected .title-option-close-masive{\r\n    color: var(--white-color);\r\n}\r\n.main-close-masive{\r\n    display: block;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n.buttons-close-masive ,.mode-close-masive{\r\n    height: 14%;\r\n    width:100%;\r\n    display:flex;\r\n    justify-content:center;\r\n    align-items:center;\r\n    gap:20px;\r\n}\r\n.buttons-close-masive{\r\n    width: 50%;\r\n    left: 25%;\r\n    position: relative;\r\n}\r\n.body-close-masive{\r\n    height: 70%;\r\n    width:100%;\r\n    display:flex;\r\n    flex-direction:column;\r\n    align-items:center;\r\n    justify-content:center;\r\n    gap:10px\r\n}\r\n\r\n.content-close-masive-options{\r\n    position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 90%;\r\n}\r\n.mode-close-masive{\r\n     box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.219);\r\n     border: 1px solid rgba(128, 128, 128, 0.411);\r\n     border-radius: 10px;\r\n     width:90%; \r\n     position: relative;\r\n     left: 5%;\r\n    }\r\n.title-text-close-masive{\r\n    color: var(--main-color);\r\n    font-weight: bold;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n}\r\n.mode-option-close-masive{\r\n    /* width:40%; */\r\n    height: 100%;\r\n    font-size: small;\r\n    color: var(--txt-color);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n}   \r\n.top-body-close-masive, .bottom-body-close-masive{\r\n    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.219);\r\n     border: 1px solid rgba(128, 128, 128, 0.411);\r\n     border-radius: 10px;\r\n     width:90%; \r\n     position: relative;\r\n     /* left: 10%; */\r\n      height: 40%;\r\n}\r\n.top-body-close-masive{ \r\n    display:flex;\r\n    flex-direction:row;\r\n    align-items:center;\r\n    justify-content:center;\r\n    gap:10px\r\n}\r\n.bottom-body-close-masive{\r\n    display:flex;\r\n    flex-direction:row;\r\n    align-items:center;\r\n    justify-content:center;\r\n    gap:10px;\r\n    height: 50%;\r\n}\r\n.text-close-masive{\r\n     background: var(--white-color);\r\n     position:relative;\r\n     resize:none;\r\n     width:90%;\r\n     height:60%;\r\n     color: var(--txt-color);\r\n     border-radius: 10px;\r\n}\r\n.lbl-text-close-masive{\r\n    position: absolute;\r\n    top: 5%;\r\n    left: 5%;\r\n    font-size: small;\r\n    color: var(--txt-color);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
